import * as React from "react";
import { Toolbar, Typography } from "@material-ui/core";
import { EarningsTotal } from "./components/earnings-total";
import { useParams } from "react-router";
import DineroFactory from "dinero.js";
import { EarningsBalance } from "./components/earnings-balance";
import { getAccount, getStatement, getBalance } from "../../sdk/royalties";
import { EarningsStatement } from "./components/earnings-statement";
import { Statement } from "../../../../../services/royalties/types/statement";
import { RoyaltiesAccount } from "../../../../../services/royalties/types/royalties-account";

export const EarningsDetailPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();

  const [loading, setLoading] = React.useState(false);
  const [statement, setStatement] = React.useState<Statement[]>([]);
  const [account, setAccount] = React.useState<RoyaltiesAccount>();
  const [balance, setBalance] = React.useState<DineroFactory.Dinero>(
    DineroFactory({ amount: 0, precision: 2, currency: "USD" })
  );

  React.useEffect(() => {
    setLoading(true);
    Promise.all([
      getStatement(userId).then((items) =>
        items ? setStatement(items) : null
      ),
      getBalance(userId).then((balance) =>
        balance ? setBalance(balance) : null
      ),
      getAccount(userId).then((data) => (data ? setAccount(data) : null)),
    ]).finally(() => setLoading(false));
  }, [userId]);

  const total = statement.reduce(
    (memo, item) => memo.add(item.earnings),
    DineroFactory({ amount: 0, precision: 2, currency: "USD" })
  );

  return (
    <section style={{ margin: "30px" }}>
      <Toolbar variant="dense">
        {account ? (
          <Typography variant="h4" style={{ flexGrow: 1 }}>
            {account.name} ({account.email})
          </Typography>
        ) : null}
      </Toolbar>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <EarningsTotal
          style={{ marginRight: "20px" }}
          total={total}
          loading={loading}
        />
        <EarningsBalance
          userId={userId}
          balance={balance}
          email={account?.email}
          loading={loading}
        />
      </div>

      <EarningsStatement
        style={{ marginTop: "20px" }}
        userId={userId}
        statement={statement}
        loading={loading}
      />
    </section>
  );
};
